import PropTypes from 'prop-types';

export const tyrePropType = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  name: PropTypes.string,
  design: PropTypes.string,
  catalogNumber: PropTypes.string,
  dimensions: PropTypes.string,
  brand: PropTypes.shape({ name: PropTypes.string }),
  season: PropTypes.shape({ name: PropTypes.string }),
  ean: PropTypes.string,
  loadRating: PropTypes.string,
  speedRating: PropTypes.string,
  rollingResistance: PropTypes.string,
  wetPerformance: PropTypes.string,
  noiseLevel: PropTypes.number,
  noiseType: PropTypes.string,
  grossPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  discountGrossPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  depth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  treadDepth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  quantity: PropTypes.number,
  deliveryDate: PropTypes.string,
  scheduleDetails: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      quantity: PropTypes.number,
    })
  ),
  selectedDeliveryDate: PropTypes.string,
  errorMessage: PropTypes.string,
  infoLoading: PropTypes.bool,
  isNotInStock: PropTypes.bool,
  notInStockQuantity: PropTypes.number,
  productInfo: PropTypes.string,
  efficiencySticker: PropTypes.string,
  erpel: PropTypes.string,
});
